/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {UnitNumberFieldViewer} from "./UnitNumberFieldViewer";
import autobind from "autobind-decorator";
import {service as EnvironmentalBenefitService} from "../../../Services/EnvironmentalBenefitService";

export class ProgramEnvironmentalBenefitsTargetValueViewer extends UnitNumberFieldViewer {
	constructor(props) {
		super(props);

		this.setInitialState({
			benefits: []
		});
	}

	@autobind
	getSelectedBenefitId() {
		if (this.props.Data.environmentalBenefitId) {
			return this.props.Data.environmentalBenefitId;
		}
	}

	@autobind
	getSelectedBenefit() {
		let benefitId = this.getSelectedBenefitId();
		return this.state.benefits.find((x) => x.environmentalBenefitId == benefitId);
	}

	//override
	@autobind
	loadData() {
		super.loadData();

		EnvironmentalBenefitService.Get()
			.then((x) => {
				this.setState({benefits: x.result});
			});
	}

	//override
	@autobind
	getUnitId() {
		let unitId = -1;
		let benefit = this.getSelectedBenefit();

		if (benefit) {
			unitId = benefit.unitId;
		}

		return unitId;
	}
}